import React, { useState } from "react";
import * as UI from "@goodgym/components";



export type CreateAddressFormProps = {
  onSaveAddress: (address: NewAddressData) => void;
  onCancel: () => void;
}

export type NewAddressData = {
  addressLine1: string;
  addressLine2: string;
  city: string;
  postCode: string;
  region: string;
  accessNotes: string;
  otherInformation: string;
  id: string;
  __typename:"NewAddressData"
}

const CreateAddressForm: React.FC<CreateAddressFormProps> = ({
  onSaveAddress,
  onCancel,
}) => {
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [postCode, setPostCode] = useState("");
  const [region, setRegion] = useState("");
  const [accessNotes, setAccessNotes] = useState("");
  const [otherInformation, setOtherInformation] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSaveAddress({
      addressLine1,
      addressLine2,
      city,
      postCode,
      region,
      accessNotes,
      otherInformation,
      id: "new-address-" + Date.now(),
      __typename:"NewAddressData"
    });
  };

  return (
    <UI.Card sx={{ p: 4, mt: 4 }}>
      <form onSubmit={handleSubmit}>
        <UI.Typography variant="h3">New address</UI.Typography>
        <UI.Typography variant="body2" sx={{ mb: 4 }}>
          Please fill in this field.
        </UI.Typography>

        <UI.Box
          sx={{
            marginTop: 4,
            marginBottom: 4,
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          <UI.Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <UI.InputLabel htmlFor="addressLine1">
              Address line 1 *
            </UI.InputLabel>
            <UI.Input
              id="addressLine1"
              value={addressLine1}
              onChange={(e) => setAddressLine1(e.target.value)}
              required
            />
          </UI.Box>

          <UI.Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <UI.InputLabel htmlFor="addressLine2">Address line 2</UI.InputLabel>
            <UI.Input
              id="addressLine2"
              value={addressLine2}
              onChange={(e) => setAddressLine2(e.target.value)}
            />
          </UI.Box>

          <UI.Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <UI.InputLabel htmlFor="city">City *</UI.InputLabel>
            <UI.Input
              id="city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              required
            />
          </UI.Box>

          <UI.Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <UI.InputLabel htmlFor="postCode">Post code *</UI.InputLabel>
            <UI.Input
              id="postCode"
              value={postCode}
              onChange={(e) => setPostCode(e.target.value)}
              required
            />
          </UI.Box>

          <UI.Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <UI.InputLabel htmlFor="region">Region</UI.InputLabel>
            <UI.Input
              id="region"
              value={region}
              onChange={(e) => setRegion(e.target.value)}
            />
          </UI.Box>

          <UI.Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <UI.InputLabel htmlFor="accessNotes">Access notes</UI.InputLabel>
            <UI.TextField
              id="accessNotes"
              value={accessNotes}
              onChange={(e) => setAccessNotes(e.target.value)}
              rows={3}
            />
          </UI.Box>

          <UI.Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <UI.InputLabel htmlFor="otherInformation">
              Other information
            </UI.InputLabel>
            <UI.TextField
              id="otherInformation"
              value={otherInformation}
              onChange={(e) => setOtherInformation(e.target.value)}
              rows={3}
            />
          </UI.Box>

          <UI.Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              paddingTop: 4,
            }}
          >
            <UI.Button type="button" onClick={onCancel}>
              Cancel
            </UI.Button>
            <UI.Button type="submit" onClick={handleSubmit}>
              Save Address
            </UI.Button>
          </UI.Box>
        </UI.Box>
      </form>
    </UI.Card>
  );
};

export default CreateAddressForm;
